<script setup lang="ts">
import { MetricType, Type } from './../utility';
import { MeasureResult } from '@Shared/utils/types';
import MetricBreakdownSection from './MetricBreakdownSection.vue';

defineProps<{
  metricType?: MetricType;
  metricBreakdown: {
    negative: MeasureResult;
    neutral: MeasureResult;
    positive: MeasureResult;
  };
  inPopup?: boolean;
}>();
</script>
<template>
  <div
    :class="{
      'grid items-center row-gap[2]': !inPopup,
      'flex flex-row flex-wrap justify-between': inPopup,
    }"
  >
    <MetricBreakdownSection
      :value="metricBreakdown.positive"
      :type="Type.Positive"
      :in-popup="inPopup"
      :metric-type="metricType"
    ></MetricBreakdownSection>
    <MetricBreakdownSection
      :value="metricBreakdown.neutral"
      :type="Type.Neutral"
      :in-popup="inPopup"
      :metric-type="metricType"
    ></MetricBreakdownSection>
    <MetricBreakdownSection
      :value="metricBreakdown.negative"
      :type="Type.Negative"
      :in-popup="inPopup"
      :metric-type="metricType"
    ></MetricBreakdownSection>
  </div>
</template>
